import script from "./Game.vue?vue&type=script&setup=true&lang=js"
export * from "./Game.vue?vue&type=script&setup=true&lang=js"

import "./Game.vue?vue&type=style&index=0&id=564fe4bd&scoped=true&lang=scss"
script.__scopeId = "data-v-564fe4bd"

export default script